


export type FormState = 'Open' | 'Done' | 'PartiallySigned' | 'Signed';

export const FormState = {
    Open: 'Open' as FormState,
    Done: 'Done' as FormState,
    PartiallySigned: 'PartiallySigned' as FormState,
    Signed: 'Signed' as FormState
};

